import { FC } from 'react';
import classNames from 'classnames';
import Icon, { IconNames } from 'components/Icon';
import colors from 'constants/colors';

interface Props {
  index: number;
  displayIndex?: number;
  itemVisible: number;
  type: string;
  tabStatus: string[];
  handleClickAccordion: (item: number) => void;
  isPreviewVisible?: boolean;
}

export const TabAccordion: FC<Props> = ({
  index,
  displayIndex,
  itemVisible,
  type,
  tabStatus,
  handleClickAccordion,
  isPreviewVisible,
}) => {
  return (
    <div
      className={classNames('card-accordion-header', {
        active: itemVisible === index,
      })}
      onClick={() => handleClickAccordion(index)}
    >
      <div className="row align-center">
        <span className="oath-body">
          {(displayIndex ?? index) + 1}. {type}
        </span>
        {tabStatus[index] === 'in-progress' ? (
          <label className="status-tab in-progress">In Progress</label>
        ) : tabStatus[index] === 'error' ? (
          <label className="status-tab error">Error - Please Fix</label>
        ) : (
          tabStatus[index] === 'success' && (
            <div className="status-tab success">
              <Icon name={IconNames.Check} color={colors.white} size={12} />
            </div>
          )
        )}
      </div>
      <Icon
        name={
          itemVisible === index
            ? isPreviewVisible
              ? IconNames.ChevronRight
              : IconNames.ChevronUp
            : IconNames.ChevronDown
        }
        color={itemVisible === index ? colors.oathBlue : colors.inkBlue}
      />
    </div>
  );
};
